// extracted by mini-css-extract-plugin
export default {"iconsContainer":"style_iconsContainer__OdjHL","footerIcon":"style_footerIcon__pc76x"};